var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},_vm._l((_vm.statusList),function(item,index){return _c('div',{key:index},[_c('div',{class:['customer', item.value === _vm.customerStatus ? 'isSelect' : ''],on:{"click":function($event){return _vm.selectStatus(item)}}},[_vm._v("\n      "+_vm._s(item.label)+"\n    ")]),_c('div',{staticClass:"line"})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }